import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import * as wConsts from "../consts/website-consts";
import * as aActs from "../actions/agency-actions";
import * as pConsts from "../consts/profiles-consts";
import AgencyItem from "../components/agencyitem";
import Pager from "../components/pager";

class AgencyList extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "agentslist" });
    this.props.dispatch(aActs.GetAgencyList());
  }

  render() {

    let agComp = () => { return <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}><img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/></p>; }

    if(this.props.AgencyList.Loaded && this.props.AgencyList.Result.Code !== 200) {
      agComp = () => { return <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}></p>; }
    }

    let aList = this.props.AgencyList.Result.Result;

    if(this.props.AgencyList.Loaded && this.props.AgencyList.Result.Code === 200) {
      agComp = () => {

        let agts;
        let out = 0;

        agts = this.props.AgencyList.Result.Result.map((agt)=>{
          out++;
          //For Now Have To Remake Image For Proper Sizes, We Will Use CDN In A Few Dayz
          //The Originals Are Wide/Tall Etc.. Need To Make Proper Sizes On Proxy Side CDN
          //I know They Are Blurry :)
          let img = "/imgs/spacer.gif";
          if(agt.Image) {
            img = agt.LogoUrl;
          }

          //Check The Blocks Dude :)
          if(typeof agt.Blocks !=="undefined" && agt.Blocks.length >= 1) {
            let cc = this.props.WebPage.Request.CountryCode; //'RU'
            let fb = false;
            agt.Blocks.forEach((v) => {
              if(v === cc) {
                fb=true; //No Way Fucker
              } else {
              }
            });
            if(fb) { return null; } //Do Not Write The Model To List :P
          }
          if(out <= pConsts.FILTER_PAGESIZE) {
            return (
              <div style={{clear: "both"}}>
                <AgencyItem key={agt.Id + "-" + this.props.AgencyList.Result.Context.Page} Agent={agt} Image={img}/>
              </div>

            );
          }
          return null;
        });
        return <div>{agts}<Pager ShowPages={3} Page={this.props.AgencyList.Result.Context.Page} TotalPages={this.props.AgencyList.Result.Context.TotalPages} /></div>;
      };
    }

    return (
      <div className="main-content left">
        <SeoHeaders Position={"Top"}/>
          <div className="escort-agencies-wrapper models-listing">
            {agComp()}
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    AgencyList: state.Agency.AgencyList,
  };
};

export default connect(mapStateToProps)(AgencyList);
